import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import triangle from "../../assets/triangle.jpg";
import info from "../../assets/infoblue.jpg";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import { Search } from "lucide-react";
import formatDate from "../../common/Formatdate";

const Batteryandtyres = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [batterandTyreData, setBatteyandTyreData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [cityFilter, setCityFilter] = useState("1");
  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  const batteryStatusCounts = useMemo(() => {
    const batteries = batterandTyreData?.batteryList || [];

    return batteries.reduce(
      (counts, battery) => {
        const status = battery?.batteryStatus?.trim().toLowerCase();

        if (status === "due") counts.due += 1;
        if (status === "overdue") counts.overdue += 1;
        if (status === "critical") counts.critical += 1;
        if (status === "active") counts.active += 1;
        if (status === "not installed") counts.notInstalled += 1;

        return counts;
      },
      { due: 0, overdue: 0, critical: 0, active: 0, notInstalled: 0 },
    );
  }, [batterandTyreData?.batteryList]);

  const tyreStatusCounts = useMemo(() => {
    const tyres = batterandTyreData?.tyreList || [];

    return tyres.reduce(
      (counts, tyre) => {
        const status = tyre?.tyreStatus?.trim().toLowerCase();

        if (status === "due") counts.due += 1;
        if (status === "overdue") counts.overdue += 1;
        if (status === "critical") counts.critical += 1;
        if (status === "active") counts.active += 1;

        return counts;
      },
      { due: 0, overdue: 0, critical: 0, active: 0 },
    );
  }, [batterandTyreData?.tyreList]);

  const batteryandTyreOverviewData = {
    counts: [
      {
        title: "Battery Replace Due",
        value: batteryStatusCounts.due,
        class: "bg-red-600",
        outof: "More than 600 days",
      },
      {
        title: "Tyre Check Due",
        value: tyreStatusCounts.due,
        class: "bg-yellow-500",
        outof: "1001-3000 km remaining",
      },
      {
        title: "Battery Overdue",
        value: batteryStatusCounts.overdue,
        class: "bg-purple-900", 
        outof: "More than 730 days",
      },
      {
        title: "Battery Critical",
        value: batteryStatusCounts.critical,
        class: "bg-red-600",
        outof: "More than 660 days",
      },
      {
        title: "Battery Not Installed",
        value: batteryStatusCounts.notInstalled,
        class: "bg-slate-500",
        outof: "No battery installed",
      },
      {
        title: "Tyre Overdue",
        value: tyreStatusCounts.overdue,
        class: "bg-purple-900",
        outof: "Less than 0 km remaining",
      },
      {
        title: "Tyre Critical",
        value: tyreStatusCounts.critical,
        class: "bg-red-600",
        outof: "0-1000 km remaining",
      },
    ],
    countsTwo: [
      {
        title: "Total Payment Pending Count",
        value:
          batterandTyreData?.countDetails?.totalBatteryPaymentPendingCount || 0,
        class: "bg-red-600",
        outof: null,
      },
      {
        title: "Total Cost to Comapny",
        value: batterandTyreData?.countDetails?.totalBatteryCostToCompany || 0,
        class: "bg-fuchsia-700",
        outof: "Total Cost",
      },
      // {
      //   title: "Payment Completed Amount",
      //   value: 0,
      //   class: "bg-blue-700",
      //   outof: "Paid Invoices",
      // },
      {
        title: "Payment Pending Amount",
        value: batterandTyreData?.countDetails?.totalBatteryPaymentPending || 0,
        class: "bg-amber-500",
        outof: "Unpaid Invoices",
      },
      {
        title: "Battery Active",
        value: batteryStatusCounts.active,
        class: "bg-green-600",
        outof: "0-600 days",
      },
    ],
    countsThree: [
      {
        title: "Total Payment Pending Count",
        value:
          batterandTyreData?.countDetails?.totalTyrePaymentPendingCount || 0,
        class: "bg-red-600",
        outof: null,
      },
      {
        title: "Total Cost to Comapny",
        value: batterandTyreData?.countDetails?.totalTyreCostToCompany || 0,
        class: "bg-fuchsia-700",
        outof: "Total Cost",
      },
      // {
      //   title: "Payment Completed Amount",
      //   value: 0,
      //   class: "bg-blue-700",
      //   outof: "Paid Invoices",
      // },
      {
        title: "Payment Pending Amount",
        value: batterandTyreData?.countDetails?.totalTyrePaymentPending || 0,
        class: "bg-amber-500",
        outof: "Unpaid Invoices",
      },
      {
        title: "Tyre Active",
        value: tyreStatusCounts.active,
        class: "bg-green-600",
        outof: "More than 3000 km remaining",
      },
    ],
  };

  const [loading, setLoading] = useState(false);
  const [batteryPage, setBatteryPage] = useState(1);
  const [tyrePage, setTyrePage] = useState(1);
  const [batteryVehicleSearch, setBatteryVehicleSearch] = useState("");
  const [tyreVehicleSearch, setTyreVehicleSearch] = useState("");
  const [batteryStatusFilter, setBatteryStatusFilter] = useState("all");
  const [tyreStatusFilter, setTyreStatusFilter] = useState("all");
  const rowsPerPage = 10;

  const matchesStatusFilter = (statusValue, statusFilter) => {
    if (statusFilter === "all") return true;

    const status = statusValue?.toLowerCase() || "";
    if (statusFilter === "due") {
      return (
        status === "due" ||
        status.includes("replace due") ||
        status.includes("due soon")
      );
    }

    return status.includes(statusFilter);
  };

  const filteredBatteryData = useMemo(() => {
    const search = batteryVehicleSearch.trim().toLowerCase();

    return (batterandTyreData?.batteryList || []).filter((battery) => {
      const vehicleNumber = battery?.vehicleRegistrationNo?.toLowerCase() || "";
      return (
        vehicleNumber.includes(search) &&
        matchesStatusFilter(battery?.batteryStatus, batteryStatusFilter)
      );
    });
  }, [
    batteryStatusFilter,
    batteryVehicleSearch,
    batterandTyreData?.batteryList,
  ]);

  const filteredTyreData = useMemo(() => {
    const search = tyreVehicleSearch.trim().toLowerCase();

    return (batterandTyreData?.tyreList || []).filter((tyre) => {
      const vehicleNumber = tyre?.vehicleRegistrationNo?.toLowerCase() || "";
      return (
        vehicleNumber.includes(search) &&
        matchesStatusFilter(tyre?.tyreStatus, tyreStatusFilter)
      );
    });
  }, [tyreStatusFilter, tyreVehicleSearch, batterandTyreData?.tyreList]);

  const paginatedBatteryData = useMemo(() => {
    const startIndex = (batteryPage - 1) * rowsPerPage;
    return filteredBatteryData.slice(startIndex, startIndex + rowsPerPage);
  }, [batteryPage, filteredBatteryData]);

  const paginatedTyreData = useMemo(() => {
    const startIndex = (tyrePage - 1) * rowsPerPage;
    return filteredTyreData.slice(startIndex, startIndex + rowsPerPage);
  }, [tyrePage, filteredTyreData]);

  const batteryTotalPages = Math.max(
    1,
    Math.ceil(filteredBatteryData.length / rowsPerPage),
  );

  const tyreTotalPages = Math.max(
    1,
    Math.ceil(filteredTyreData.length / rowsPerPage),
  );

  const getBatterandTyreDatApi = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    // const formattedStartDate = formatDateForApi(
    //   selectionRange?.startDate,
    //   "start",
    // );
    // const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    // ?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/battery-tyre-dashboard?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setBatteyandTyreData(data?.dataValues);
        setBatteryPage(1);
        setTyrePage(1);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      toast.error("Error fetching Battery and Tyre data");
      setLoading(false);
      console.error("Error fetching Battery and Tyre data:", error);
    }
  };

  useEffect(() => {
    getBatterandTyreDatApi();
  }, []);

  const getBatteryDaysLeft = (installedDate) => {
    if (!installedDate) return "N/A";

    const installed = new Date(installedDate);
    const expiry = new Date(installed);
    expiry.setDate(expiry.getDate() + 730);

    const today = new Date();

    const diffTime = expiry - today;
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return daysLeft > 0 ? `${daysLeft} Days Left` : "-";
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mt-4 px-4">
        <h1 className="text-gray-900 text-2xl pt-4 font-bold tracking-tight">
          Battery and Tyres
        </h1>
        <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
          <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              className="flex-shrink-0 w-4 h-4"
            >
              <path
                d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                stroke="#99A1AF"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                stroke="#99A1AF"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <Citiescommondropdown
              value={cityFilter}
              onChange={setCityFilter}
              options={[{ value: null, label: "All Cities" }, ...cityOptions]}
              placeholder="City"
              className="flex-1 min-w-[80px]"
              showSearch={true}
            />
          </div>
          <button
            onClick={() => {
              getBatterandTyreDatApi();
            }}
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <Search size={18} />
            Search
          </button>
        </div>
      </div>

      <div className="w-full p-6 md:p-8 flex flex-col gap-6 overflow-visible">
        {/* ==================== TOP OVERVIEW CARDS (not wired to API yet) ==================== */}
        <div className="self-stretch inline-flex flex-wrap justify-start items-start gap-5 pb-4">
          {batteryandTyreOverviewData &&
            batteryandTyreOverviewData?.counts?.map((data, index) => (
              <div
                key={index}
                className="flex-1 min-w-[220px] h-32 p-5 relative bg-white rounded-bl-xl rounded-br-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4"
              >
                <div
                  className={`w-[95%] h-2 left-[10px] top-0 absolute rounded-bl-lg rounded-br-lg ${data?.class}`}
                />
                <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
                  {data?.title}
                </div>
                <div className="self-stretch flex flex-col justify-start items-start gap-1">
                  <div className="justify-start text-slate-900 text-3xl font-bold font-['Inter']">
                    {data?.value}
                  </div>
                  {data?.outof && (
                    <div className="self-stretch justify-start text-slate-400 text-sm font-normal font-['Inter']">
                      {data?.outof}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>

        {/* ==================== BATTERY SUMMARY ==================== */}
        <div className="bg-white rounded-2xl outline outline-1 outline-offset-[-1px] outline-neutral-100 p-5 flex flex-col gap-3">
          <div className="text-slate-900 text-sm font-bold font-['Inter'] uppercase tracking-tight">
            Battery
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {batteryandTyreOverviewData &&
              batteryandTyreOverviewData?.countsTwo?.map((data, index) => (
                <div
                  key={index}
                  className="relative bg-white rounded-xl border border-slate-200 overflow-hidden"
                >
                  <div className={`h-1 w-full ${data?.class}`} />
                  <div className="p-4 flex flex-col gap-1.5">
                    <div className="text-slate-500 text-[10px] font-semibold font-['Inter'] uppercase tracking-wide">
                      {data?.title}
                    </div>
                    <div className="text-slate-900 text-xl font-bold font-['Inter']">
                      {data?.value}
                    </div>
                    <div className="text-slate-400 text-xs font-normal font-['Inter']">
                      {data?.outof}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* ==================== TYRE SUMMARY ==================== */}
        <div className="bg-white rounded-2xl outline outline-1 outline-offset-[-1px] outline-neutral-100 p-5 flex flex-col gap-3">
          <div className="text-slate-900 text-sm font-bold font-['Inter'] uppercase tracking-tight">
            Tyre
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {batteryandTyreOverviewData &&
              batteryandTyreOverviewData.countsThree?.map((data, index) => (
                <div
                  key={index}
                  className="relative bg-white rounded-xl border border-slate-200 overflow-hidden"
                >
                  <div className={`h-1 w-full ${data?.class}`} />
                  <div className="p-4 flex flex-col gap-1.5">
                    <div className="text-slate-500 text-[10px] font-semibold font-['Inter'] uppercase tracking-wide">
                      {data?.title}
                    </div>
                    <div className="text-slate-900 text-xl font-bold font-['Inter']">
                      {data?.value}
                    </div>
                    <div className="text-slate-400 text-xs font-normal font-['Inter']">
                      {data?.outof}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full items-stretch">
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden h-full flex flex-col">
            <div className="p-5 flex flex-row justify-between gap-3">
              <h2 className="text-sm font-bold uppercase tracking-tight text-slate-900 font-['Inter']">
                Battery Tracker
              </h2>
              <div className="flex flex-col sm:flex-row gap-2">
                <div className="relative flex-1">
                  <Search
                    size={16}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                  />
                  <input
                    type="search"
                    value={batteryVehicleSearch}
                    onChange={(event) => {
                      setBatteryVehicleSearch(event.target.value);
                      setBatteryPage(1);
                    }}
                    placeholder="Search vehicle no"
                    aria-label="Search battery tracker by vehicle number"
                    className="w-full rounded-md border border-slate-300 py-2 pl-9 pr-3 text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <select
                  value={batteryStatusFilter}
                  onChange={(event) => {
                    setBatteryStatusFilter(event.target.value);
                    setBatteryPage(1);
                  }}
                  aria-label="Filter battery tracker by status"
                  className="rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-700 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                >
                  <option value="all">All Statuses</option>
                  <option value="overdue">Overdue</option>
                  <option value="critical">Critical</option>
                  <option value="due">Due Soon</option>
                </select>
              </div>
            </div>

            <div className="px-4 py-2.5 bg-[#FEF3C7] border-y border-amber-100 flex items-center gap-2.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.00004 5.99935V8.66602M8.00004 11.3327H8.00671M14.487 11.9995L9.15365 2.66617C9.03736 2.46097 8.86872 2.29029 8.66494 2.17154C8.46115 2.0528 8.22951 1.99023 7.99365 1.99023C7.75779 1.99023 7.52616 2.0528 7.32237 2.17154C7.11858 2.29029 6.94994 2.46097 6.83365 2.66617L1.50032 11.9995C1.38277 12.2031 1.32114 12.4341 1.32166 12.6692C1.32218 12.9042 1.38484 13.135 1.50328 13.338C1.62173 13.5411 1.79175 13.7092 1.99612 13.8254C2.20048 13.9415 2.43192 14.0016 2.66699 13.9995H13.3337C13.5676 13.9993 13.7973 13.9375 13.9998 13.8204C14.2023 13.7032 14.3705 13.5349 14.4873 13.3322C14.6042 13.1296 14.6657 12.8998 14.6656 12.6658C14.6656 12.4319 14.604 12.2021 14.487 11.9995Z"
                  stroke="#D97706"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <p className="text-xs text-amber-600 font-medium font-['Inter']">
                Replace every 2 years. Distilled water: every year.
              </p>
            </div>

            {/* Battery Table */}
            <div className="overflow-x-auto flex-1">
              <table className="min-w-max w-full">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-200">
                    <th className="w-40 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Vehicle No
                    </th>

                    <th className="w-32 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Vehicle Name
                    </th>

                    <th className="w-32 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      City
                    </th>

                    <th className="w-36 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Warranty Status
                    </th>

                    <th className="w-36 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Warranty End Date
                    </th>

                    <th className="w-36 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Battery Installed
                    </th>

                    <th className="w-36 px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Days Left
                    </th>

                    <th className="w-28 px-5 py-3 text-right text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedBatteryData.length > 0 ? (
                    paginatedBatteryData.map((data, index) => (
                      <tr
                        key={`${data?.vehicleRegistrationNo || index}-${index}`}
                        className="border-b border-slate-100 last:border-b-0"
                      >
                        <td className="px-5 py-4 text-xs font-semibold font-['Inter'] text-slate-900 whitespace-nowrap">
                          {data?.vehicleRegistrationNo || "-"}
                        </td>

                        <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                          {data?.name || "N/A"}
                        </td>

                        <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                          {data?.city || "N/A"}
                        </td>

                        <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                          {data?.warrantyStatus || "N/A"}
                        </td>

                        <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                          {formatDate(data?.warrantyEndDate) || "-"}
                        </td>

                        <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                          {formatDate(data?.batteryInstalledOn) || "-"}
                        </td>

                        <td className="px-5 py-4 whitespace-nowrap">
                          <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-red-50 text-red-600 text-[10px] font-semibold uppercase">
                            {getBatteryDaysLeft(data?.batteryInstalledOn)}
                          </span>
                        </td>

                        <td className="px-5 py-4 text-right whitespace-nowrap">
                          <span
                            className={`inline-block px-2 py-1 rounded-md text-[10px] font-bold font-['Inter'] uppercase ${
                              data?.batteryStatus?.toLowerCase() === "active"
                                ? "bg-green-100 text-green-600"
                                : data?.batteryStatus?.toLowerCase() ===
                                    "overdue"
                                  ? "bg-red-100 text-red-600"
                                  : data?.batteryStatus?.toLowerCase() === "due"
                                    ? "bg-yellow-100 text-yellow-600"
                                    : "bg-gray-100 text-gray-600"
                            }`}
                          >
                            {data?.batteryStatus || "N/A"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="px-5 py-6 text-center text-sm text-slate-500 whitespace-nowrap"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Battery Pagination */}
            <div className="flex items-center justify-between px-5 py-4 border-t border-slate-200 bg-white">
              <div className="text-xs text-slate-500 whitespace-nowrap">
                Showing{" "}
                {paginatedBatteryData.length > 0
                  ? (batteryPage - 1) * rowsPerPage + 1
                  : 0}
                -
                {Math.min(
                  batteryPage * rowsPerPage,
                  filteredBatteryData.length,
                )}{" "}
                of {filteredBatteryData.length}
              </div>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() =>
                    setBatteryPage((prev) => Math.max(1, prev - 1))
                  }
                  disabled={batteryPage === 1}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  Prev
                </button>

                <span className="text-xs text-slate-600 whitespace-nowrap">
                  Page {batteryPage} of {batteryTotalPages}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    setBatteryPage((prev) =>
                      Math.min(batteryTotalPages, prev + 1),
                    )
                  }
                  disabled={batteryPage === batteryTotalPages}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden h-full flex flex-col">
            <div className="p-5 flex flex-row justify-between gap-3">
              <h2 className="text-sm font-bold uppercase tracking-tight text-slate-900 font-['Inter']">
                Tyre Reminder
              </h2>
              <div className="flex flex-col sm:flex-row gap-2">
                <div className="relative flex-1">
                  <Search
                    size={16}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                  />
                  <input
                    type="search"
                    value={tyreVehicleSearch}
                    onChange={(event) => {
                      setTyreVehicleSearch(event.target.value);
                      setTyrePage(1);
                    }}
                    placeholder="Search vehicle no"
                    aria-label="Search tyre reminder by vehicle number"
                    className="w-full rounded-md border border-slate-300 py-2 pl-9 pr-3 text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <select
                  value={tyreStatusFilter}
                  onChange={(event) => {
                    setTyreStatusFilter(event.target.value);
                    setTyrePage(1);
                  }}
                  aria-label="Filter tyre reminder by status"
                  className="rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-700 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                >
                  <option value="all">All Statuses</option>
                  <option value="overdue">Overdue</option>
                  <option value="critical">Critical</option>
                  <option value="due">Due Soon</option>
                </select>
              </div>
            </div>

            <div className="px-4 py-2.5 bg-blue-50 border-y border-blue-100 flex items-center gap-2.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_194_1435)">
                  <path
                    d="M7.99996 10.6671V8.00021M7.99996 5.33333H8.00663M14.6672 8.00021C14.6672 11.6824 11.6822 14.6674 7.99996 14.6674C4.31777 14.6674 1.33276 11.6824 1.33276 8.00021C1.33276 4.31801 4.31777 1.33301 7.99996 1.33301C11.6822 1.33301 14.6672 4.31801 14.6672 8.00021Z"
                    stroke="#3B82F6"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_194_1435">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <p className="text-xs text-blue-500 font-['Inter']">
                Inspection every <span className="font-bold">40k-50k</span> km
              </p>
            </div>

            {/* Tyre Table */}
            <div className="overflow-x-auto flex-1">
              <table className="min-w-max w-full">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-200">
                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Vehicle Number
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Vehicle Name
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      City
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Tyre Position
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Tyre Type
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Installed Date
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Kilometer Limit
                    </th>

                    <th className="px-5 py-3 text-left text-[10px] font-semibold font-['Inter'] uppercase tracking-wide text-slate-400 whitespace-nowrap">
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedTyreData.length > 0 ? (
                    paginatedTyreData.map((data, index) => {
                      const tyreStatuses =
                        data?.tyreStatus
                          ?.split(",")
                          .map((item) => item.trim()) || [];

                      return (
                        <tr
                          key={`${data?.vehicleRegistrationNo || index}-${index}`}
                          className="border-b border-slate-100 last:border-b-0"
                        >
                          <td className="px-5 py-4 text-xs font-semibold font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.vehicleRegistrationNo || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.name || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.city || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.tyrePosition || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.tyreType || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.installedDate || "N/A"}
                          </td>

                          <td className="px-5 py-4 text-xs font-normal font-['Inter'] text-slate-900 whitespace-nowrap">
                            {data?.kilometerLimit || "N/A"}
                          </td>

                          <td className="px-5 py-4 whitespace-nowrap">
                            <div className="flex items-center gap-2">
                              {tyreStatuses.length > 0 ? (
                                tyreStatuses.map((status, statusIndex) => {
                                  let statusClass = "bg-gray-100 text-gray-500";

                                  if (status === "Active") {
                                    statusClass = "bg-green-100 text-green-600";
                                  } else if (status === "Critical") {
                                    statusClass = "bg-red-100 text-red-600";
                                  } else if (status === "Due") {
                                    statusClass =
                                      "bg-yellow-100 text-yellow-600";
                                  } else if (status === "Overdue") {
                                    statusClass =
                                      "bg-purple-100 text-purple-600";
                                  }

                                  return (
                                    <span
                                      key={`${status}-${statusIndex}`}
                                      className={`px-2 py-1 rounded-md text-[10px] font-bold font-['Inter'] uppercase whitespace-nowrap ${statusClass}`}
                                    >
                                      {status}
                                    </span>
                                  );
                                })
                              ) : (
                                <span className="px-2 py-1 rounded-md text-[10px] font-bold font-['Inter'] uppercase bg-gray-100 text-gray-500">
                                  N/A
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        className="px-5 py-6 text-center text-sm text-slate-500 whitespace-nowrap"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Tyre Pagination */}
            <div className="flex items-center justify-between px-5 py-4 border-t border-slate-200 bg-white">
              <div className="text-xs text-slate-500 whitespace-nowrap">
                Showing{" "}
                {paginatedTyreData.length > 0
                  ? (tyrePage - 1) * rowsPerPage + 1
                  : 0}
                -{Math.min(tyrePage * rowsPerPage, filteredTyreData.length)} of{" "}
                {filteredTyreData.length}
              </div>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setTyrePage((prev) => Math.max(1, prev - 1))}
                  disabled={tyrePage === 1}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  Prev
                </button>

                <span className="text-xs text-slate-600 whitespace-nowrap">
                  Page {tyrePage} of {tyreTotalPages}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    setTyrePage((prev) => Math.min(tyreTotalPages, prev + 1))
                  }
                  disabled={tyrePage === tyreTotalPages}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Batteryandtyres;
